define('services/cloudacademy/cloud-academy.service',['app'], function (app) {
    return app.factory('cloudAcademyService', ['$q','OpenUp','auiDialog','$sce', function ($q, OpenUp,auiDialog,$sce) {
        var userTypeCorp  =2;

    	function updateLecturer(param){
            var defer = $q.defer();
            
            OpenUp.updateLecturer(param).then(function(resp){
                defer.resolve(resp);
            }).catch(function(e){
            	defer.reject();
            });
            return defer.promise;
        }
    	
        function queryLecturerInfo() {
        	var defer = $q.defer();
        	OpenUp.queryLecturerInfo().then(function(resp){
                defer.resolve(resp);
            }).catch(function(e){
            	defer.reject();
            });
            return defer.promise;
        }
        
        function getPositionList(){
        	var defer = $q.defer();
        	OpenUp.getPositionList().then(function(resp){
            	if(resp.resultCode == 0){
            		defer.resolve(resp.positionInfoList);
            	}else{
            		defer.reject();
            	}
            }).catch(function(e){
            	defer.reject();
            });
            return defer.promise;
        }

        /**
         * 依据用户类型+实名认证状态跳转正确的实名认证页面
         * @param userType 用户类型
         * @param verifyRealState 实名认证状态
         */
        function checkRealState(userType, verifyRealState){
            var defer = $q.defer();
            if(userType){
                //verifyRealState =3 首次实名认证审核未通过 0表示重新實名認證 0 未提交 1 审核中 2 审核通过 3 驳回
                 if(verifyRealState == 3 || verifyRealState == 0){
                     window.sessionStorage.setItem("fromAcademy", true);
                    //如果是企业用户，调整到企业用户页面
                    if (userType == userTypeCorp) {
                        AUI.BaseJSUtil.redirectUrl(systemParaConf.user.userDeveloperCorpUrl);
                    }else{
                        AUI.BaseJSUtil.redirectUrl(systemParaConf.user.userDeveloperUrl);
                    }
                }else{
                     defer.resolve();
                 }
            }else{
                //沒有用戶類型到用戶選擇頁面
                window.sessionStorage.setItem("fromAcademy", true);
                AUI.BaseJSUtil.redirectUrl( systemParaConf.user.userAuthSelUrl);
            }
            return defer.promise;
        }
        return {
        	updateLecturer:updateLecturer,
        	queryLecturerInfo:queryLecturerInfo,
        	getPositionList:getPositionList,
            checkRealState:checkRealState
        }

    }]);
});


